import { Button } from "@mui/material";

function SectionHeadingButton({ children }) {
  return (
    <Button
      variant="contained"
      sx={{
        borderRadius: "46px",
        px: "26px",
        minWidth: "auto",
        width: "auto",
        textTransform: "none",
        bgcolor: "#F8F8F8",
        color: "#000000",
        boxShadow: "none",
        py: "14px",
        fontSize: "20px",
        lineHeight: "30px",
        fontFamily: "Inter",
        fontWeight: "500",
        border: "1px solid #000000",
        alignSelf: "center",
      }}
    >
      {children}
    </Button>
  );
}

export default SectionHeadingButton;
